import WidgetLoader from './WidgetLoader.js';
import AngularHelper from '../angular/AngularHelper.js';

var arrWidgets = [];

class WidgetService {
	static init(msgbus, callback = () => {}) {
		var loader = new WidgetLoader(msgbus);
		loader.load(widgets => {
			arrWidgets = widgets;
			console.warn(widgets)
			callback(widgets);
		});
	}

	static isCustomQueryWidget(widgetCtx){
		if(!widgetCtx || !widgetCtx.type){
			return false;
		}
		var type = widgetCtx.type;
		if(type ==='datetimepicker' || type ==='selectbox' || type ==='multiselect' || type ==='inputbox'){
			return true;
		}
		return false;
	}

	static isCustomQueryWidgetType(type){
		if(type ==='datetimepicker' || type ==='selectbox' || type ==='multiselect' || type ==='inputbox'){
			return true;
		}
		return false;
	}

	static get(type) {
		if(!!arrWidgets[type]) {
			return new arrWidgets[type]();
		}
		else {
			return AngularHelper.inject.service(type + 'WidgetService');
		}
	}

}

export default WidgetService;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/dashboard/WidgetService.js